/*
----------------------------
Module - regional-repairer-carousel
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';
    
    fmg.repairerCarousel = function () {

        function setupRegionButtons() {

            var $region_btn = $(".regional-repairer-carousel__region-btn");

            var $back_btn = $(".regional-repairer-carousel__back-btn");

            $region_btn.on("click", function(e){

                var $this = $(this);

                var repairer_id = $this.data("repairers");

                // Pass in the parent folder id
                showRepairers(repairer_id, e.detail);

            });

            $back_btn.on("click", function(e){

                var event_type = e.detail;

                hideRepairers(event_type);

            })

        }

        function scrollToTop() {

            // Scroll to the top of the carousel
            $("html,body").animate({

                scrollTop: $carousel.offset().top - 120

            });

        }

        function showRepairers(id, event_type) {

            var $selected_repairer = $repairers.filter("[data-repairers='"+id+"']");

            var screen_size = fmg.vars.screensize;

            $repairers.removeClass("fadeOutRight");

            $islands.removeClass("fadeInLeft").addClass("fadeOutLeft"); 

            $selected_repairer.removeClass("fadeOutLeft").addClass("fadeInRight");

            // If keypress
            if(event_type == 0) {
                $selected_repairer.find(".regional-repairer-carousel__back-btn").trigger("focus");
            }

            // Run scroll 
            if(screen_size == 1) {

                scrollToTop();

            }

        }

        function hideRepairers(event_type) {

            var $current_repairer = $repairers.filter('.fadeInRight');

            var current_repairer_id = $current_repairer.data("repairers");

            var $current_region_btn = $(".regional-repairer-carousel__region-btn").filter("[data-repairers='" + current_repairer_id + "']");

            var screen_size = fmg.vars.screensize;

            $repairers.removeClass("fadeOutRight");
            
            $islands.removeClass("fadeOutLeft").addClass("fadeInLeft");

            $current_repairer.removeClass("fadeInRight").addClass("fadeOutRight");

            // If keypress
            if(event_type == 0) {
                $current_region_btn.trigger("focus");
            }

            // Run scroll 
            if(screen_size == 1) {

                scrollToTop();

            }

        }

        function init() {

            // var $carousel = $(".regional-repairer-carousel");

            if($carousel.length) {

                setupRegionButtons();

            }

        }

        var $carousel = $(".regional-repairer-carousel");
        var $islands = $(".regional-repairer-carousel__islands");
        var $repairers = $(".regional-repairer-carousel__repairers");
        
        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.repairerCarousel.init();
    });
    
}());
